export const PROFILE_DRAWER_OPEN_PARAM = 'profileDrawer';
export const PROFILE_DRAWER_OPEN_PARAM_VALUE = 'open';
